import React, { memo } from 'react';
import { Icon } from 'Components/Icons';

import { Label } from 'Components/Label';
import { TextBox } from 'Components/TextBox';
import { PurpleButton } from 'Components/Button';
import { ValidateBackGround } from 'Components/Validation';
import { CheckBox } from 'Components/CheckBox';
import { AtmosphericLogDropzone } from 'Containers/RocketDry';

import { Modal } from 'Components/Modal';

import formClasses from 'Themes/form/form.module.css';
import classes from './addLogModal.module.css';

interface Props {
  // modal variables
  isOpen: boolean;
  formErrors: any;
  isProcessing: boolean;

  // moisture log variables
  latestAverage?: string;
  photo?: File;
  removed?: boolean;

  // modal functions
  onAddReadingButtonClick: (e: any) => void;
  closeModal: (e: any) => void;

  // moisture log functions
  onChangeLatestAverage: (e: any) => void;
  onRemovedCheckboxClick: (e: any) => void;
  setPhoto: any; // needs to be this type or else the dropzone component will error
}

function AddMoistureLogReadingModal({
  isOpen,
  formErrors,
  isProcessing,
  latestAverage,
  removed,
  photo,
  onAddReadingButtonClick,
  closeModal,
  onChangeLatestAverage,
  onRemovedCheckboxClick,
  setPhoto,
}: Props) {
  return (
    <Modal title="Damage Material Log" isOpen={isOpen} classes={{ modalDialog: classes.modalOverride }}>
      <h5 className={classes.heading}>
        Damage Material Log <Icon type="close" className={classes.closeModal} onClick={closeModal} />
      </h5>
      <form
        className={`requires-validation g-3 ${formClasses.formBase} ${classes.container}`}
        noValidate
        action="#"
        onSubmit={() => {}}
      >
        <div className={classes.formWrapper}>
          <div>
            <div className={classes.photoUploadContainer}>
              {photo && (
                <div>
                  <img src={URL.createObjectURL(photo)} alt="meter readings" />
                  <Icon type="closecircle" className={classes.deleteImageIcon} onClick={() => setPhoto(null)} />
                </div>
              )}
              {!photo && <AtmosphericLogDropzone setPhoto={setPhoto} />}
            </div>
          </div>
          {!removed && (
            <div>
              <ValidateBackGround isValid={!formErrors?.latestAverage?.length}>
                <Label ariaLabel="Latest Average" className={formClasses.label} htmlFor="latestAverage">
                  Latest Average
                </Label>
                <TextBox
                  value={latestAverage}
                  name="latest average"
                  type="text"
                  className={`mb-0 pb-0 ${formClasses.validateField} ${
                    formErrors?.latestAverage?.length ? formClasses.invalidField : formClasses.validField
                  } ${formErrors?.latestAverage?.length ? 'is-invalid' : ''}`}
                  placeholder=""
                  ariaLabel="Please enter the latest average"
                  onChange={onChangeLatestAverage}
                  autoComplete="off"
                />
                <div className={`${formClasses.invalidFieldFeedback} invalid-feedback`}>{formErrors.latestAverage}</div>
              </ValidateBackGround>
            </div>
          )}
          <div>
            <CheckBox checked={removed} className={classes.checkbox} onChange={onRemovedCheckboxClick} /> Material
            Removed
          </div>
          <div className={`modal-footer ${classes.modalFooter}`}>
            <PurpleButton onClick={closeModal} className={classes.cancelButton}>
              Cancel
            </PurpleButton>
            <PurpleButton
              onClick={onAddReadingButtonClick}
              className={classes.saveButton}
              disabled={isProcessing || (!latestAverage && !removed)}
            >
              Save
            </PurpleButton>
          </div>
        </div>
      </form>
    </Modal>
  );
}

AddMoistureLogReadingModal.defaultProps = {
  latestAverage: undefined,
  removed: undefined,
};

const AddMoistureLogReadingModalMemo = memo(AddMoistureLogReadingModal);

export { AddMoistureLogReadingModalMemo as AddMoistureLogReadingModal };
